module.exports = __webpack_public_path__ + "img/0add03f.svg";